import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Mostrar las frases_h.
 * @autor Paul Valencia
 */
export async function getPhrasesH({commit}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('et_products_phrases_h');
        commit('setCategories', response.data)
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Frases de un producto.
 * @params state.filter : product_id,company_id
 * @autor Paul Valencia
 */
export async function getEtProductPhrase({commit, state}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('et_products_phrases', {params: state.filter});
        commit('setEtProductPhrases', response.data)
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Crear frases.
 * @params payload
 * @autor Paul Valencia
 */
export async function createPhrases({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        await $http.post('et_products_phrases', payload);
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
        return Promise.reject('error');
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener frases H, frases P y Clases de peligro.
 *
 * @params payload
 * @autor Paul Valencia
 * @return pictograms, clases_peligro, palabra_advertencia, frases_h, frases_p
 */
export async function getCompleteSga({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('get_complete_sga', {params: payload});
        commit('setCompleteSga', response.data);
    } catch (error) {
        const htmlErrors = window.listErrors(error);
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: htmlErrors,
            showConfirmButton: false,
            timer: 2000
        });
        return Promise.reject('error');
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}






